/**
 * Append a timestamped note to a PRO's scheduling comments, matching the
 * LC page convention: "MM/DD HH:MM comment", joined to any existing
 * comments with " - ".
 */
export function appendTimestampedComment(
  existing: string | null | undefined,
  comment: string,
  now: Date = new Date()
): string {
  const mm = String(now.getMonth() + 1).padStart(2, '0');
  const dd = String(now.getDate()).padStart(2, '0');
  const hh = String(now.getHours()).padStart(2, '0');
  const min = String(now.getMinutes()).padStart(2, '0');
  const stamped = `${mm}/${dd} ${hh}:${min} ${comment}`;

  if (existing && existing.trim()) {
    return `${existing} - ${stamped}`;
  }
  return stamped;
}
